const shortener = (state = {
  isSending: false,
  isShortened: false,
  showModal: false,
  response: {}
}, action) => {
  switch (action.type) {
    case 'SHORTEN_START':
      return Object.assign({}, state, {
        isSending: true,
        isShortened: false
      })
    case 'SHORTEN_SUCCESS':
      return Object.assign({}, state, {
        isSending: false,
        isShortened: true,
        showModal: true,
        response: action.response
      })
    case 'SHORTEN_FAILED':
      return Object.assign({}, state, {
        isSending: false,
        isShortened: false,
        showModal: true,
        response: action.response
      })
    case 'SHORTENER_CLOSE_MODAL':
      return Object.assign({}, state, {
        showModal: false,
      })
    default:
      return state
  }
}

export default shortener;




// WEBPACK FOOTER //
// ./src/reducers/shortener.js